import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingBackdrop from './LoadingBackdrop';

const FilePreviewModal = (props) => {  
  let viewerUrl = '';
  if(props.fileName) {          
    viewerUrl = props.fileUrl;
  }    
  
  return (
    <>    
      {props.loading ? <LoadingBackdrop /> : <Dialog open={props.open} onClose={props.onClose} maxWidth="lg" fullWidth>
        <DialogTitle>        
          <IconButton
            aria-label="close"
            onClick={props.onClose}
            sx={{ position: 'absolute', right: 16, top: 16 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {props.fileName ? <Box sx={{ height: '600px' }}>          
            <img src={viewerUrl} width="100%" height="100%" />
          </Box>:
          <Box sx={{ height: '100px' }}>
            {props.error}
          </Box>}
        </DialogContent>
      </Dialog>}
    </>
  );
};

export default FilePreviewModal;
